import React from "react";
import { GitBranch } from "lucide-react";
import "../../css/UpcomingReleases.css";

// Items come from the change log data (editable at /admin/change-log).
// Keep this list to work that is genuinely not released yet.
export default function UpcomingReleases({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className="upcoming">
      <div className="upcoming__head">
        <span className="ft-badge ft-badge--new">Coming soon</span>
      </div>
      <div className="upcoming__list">
        {items.map(({ title, text }, i) => (
          <div className="upcoming__item" key={`${title}-${i}`}>
            <span className="upcoming__icon">
              <GitBranch size={20} aria-hidden="true" />
            </span>
            <div>
              <h2 className="upcoming__title">{title}</h2>
              {text && <p className="mb-0">{text}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
